(() => {
  if (customElements.get('bj-collection-filters')) return;
  class CollectionFilters extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-bj-status]');
      this.view = this.querySelector('[data-bj-view]');
      this.version = 0;
      this.querySelector('[data-bj-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right) this.dialog.close();
        }
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow;
        document.querySelectorAll('[data-bj-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
        this.opener?.focus({preventScroll:true});
      });
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (this.validPrice()) { const url = this.buildURL(); if (url.pathname.replace(/\/$/, '') === '/collections/high-jewellery') { url.hash = this.section.id; this.dialog.close(); } location.assign(url.href); }
      });
      this.form.addEventListener('input', event => {
        if (event.target.matches('input[type=range]')) this.syncPrice(event.target);
        if (event.target.matches('input[type=number],input[type=range]')) this.changed();
      });
      this.form.addEventListener('change', event => {
        if (event.target.matches('input[type=checkbox]')) this.changed();
      });
      this.querySelector('[data-bj-clear]').addEventListener('click', () => {
        this.form.querySelectorAll('input[type=checkbox]').forEach(input => input.checked = false);
        this.form.querySelectorAll('input[type=number]').forEach(input => input.value = '');
        this.changed();
      });
      this.updateUI();
      this.bindDesktop(); if (location.pathname.replace(/\/$/, '') === '/collections/high-jewellery') this.section.style.scrollMarginTop = '100px';
    }
    open(button) {
      if (button.dataset.filter && matchMedia('(min-width:1000px)').matches) {
        this.openDropdown(button);
        return;
      }
      this.closeDropdown();
      this.liveApply = false;
      this.opener = button;
      if (!this.dialog.open) {
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      }
      button.setAttribute('aria-expanded','true');
      const group = Array.from(this.querySelectorAll('[data-bj-group]')).find(item => item.dataset.bjGroup === button.dataset.filter);
      if (group) {
        group.open = true;
        group.scrollIntoView({block:'start'});
      }
    }
    buildURL() {
      const url = new URL(location.href);
      Array.from(url.searchParams.keys()).forEach(key => {
        if (key.startsWith('filter.') || key === 'page' || key === 'section_id') url.searchParams.delete(key);
      });
      new FormData(this.form).forEach((value,key) => {
        if (key.startsWith('filter.') && value !== '') url.searchParams.append(key,value);
      });
      return url;
    }
    validPrice() {
      const price = this.querySelector('[data-bj-price]');
      if (!price) return true;
      const min = price.querySelector('[data-bj-min]');
      const max = price.querySelector('[data-bj-max]');
      max.setCustomValidity(min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value) ? 'Maximum price must be at least the minimum price.' : '');
      return min.validity.valid && max.validity.valid;
    }
    syncPrice(input) {
      const price = input.closest('[data-bj-price]');
      const low = price.querySelector('[data-bj-range-min]');
      const high = price.querySelector('[data-bj-range-max]');
      if (Number(low.value) > Number(high.value)) {
        if (input === low) low.value = high.value; else high.value = low.value;
      }
      price.querySelector('[data-bj-min]').value = Number(low.value) === 0 ? '' : low.value;
      price.querySelector('[data-bj-max]').value = Number(high.value) === Number(price.dataset.max) ? '' : high.value;
    }
    updateUI() {
      const chips = this.querySelector('[data-bj-chips]');
      chips.replaceChildren();
      const chip = (text,remove) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = text + ' ×';
        button.setAttribute('aria-label','Remove ' + text);
        button.addEventListener('click',() => {remove();this.changed();});
        chips.append(button);
      };
      this.querySelectorAll('[data-bj-group]').forEach(group => {
        const checked = Array.from(group.querySelectorAll('input[type=checkbox]:checked'));
        checked.forEach(input => chip(input.dataset.label,() => input.checked = false));
        let count = checked.length;
        const price = group.querySelector('[data-bj-price]');
        if (price) {
          const min = price.querySelector('[data-bj-min]');
          const max = price.querySelector('[data-bj-max]');
          price.querySelector('[data-bj-range-min]').value = min.value || 0;
          price.querySelector('[data-bj-range-max]').value = max.value || price.dataset.max;
          if (min.value !== '' || max.value !== '') {
            count++;
            chip('Price: ' + (min.value || '0') + ' – ' + (max.value || price.dataset.max),() => {min.value = '';max.value = '';});
          }
        }
        group.querySelector('[data-bj-selected-count]').textContent = count ? '(' + count + ')' : '';
      });
      this.querySelector('.bj-filters__applied').hidden = !chips.children.length;
    }
    changed() {
      this.updateUI();
      clearTimeout(this.timer);
      this.controller?.abort();
      this.version++;
      if (!this.validPrice()) {
        this.section.querySelector('.sf--collection-container')?.removeAttribute('aria-busy');
        this.status.textContent = 'Please enter a valid price range.';
        this.view.textContent = 'View results';
        if (this.popupStatus) this.popupStatus.textContent = 'Enter a valid price range.';
        return;
      }
      this.status.textContent = 'Updating results…';
      this.view.textContent = 'View results';
      const version = this.version;
      this.popupStatus && (this.popupStatus.textContent = this.validPrice() ? "Updating products…" : "Enter a valid price range.");
      const apply = this.liveApply;
      this.timer = setTimeout(() => this.refresh(version,apply),250);
    }
    async refresh(version,apply = false,target = null,pop = false) {
      this.controller = new AbortController();
      const url = target ? new URL(target) : this.buildURL();
      const destination = new URL(url);
      if (apply) this.section.querySelector(".sf--collection-container")?.setAttribute("aria-busy","true");
      url.searchParams.set('section_id',this.dataset.section);
      try {
        const response = await fetch(url,{signal:this.controller.signal});
        if (!response.ok) throw new Error('Unable to load filters');
        const html = await response.text();
        if (version !== this.version || !this.isConnected) return;
        const doc = new DOMParser().parseFromString(html,'text/html');
        const fresh = doc.querySelector('bj-collection-filters');
        if (!fresh) throw new Error('Missing filters');
        if (apply) this.applyResults(doc,fresh,destination,pop,!!target);
        this.view.textContent = 'View ' + fresh.dataset.count + ' results';
        this.status.textContent = fresh.dataset.count + ' matching products';
        const options = new Map(Array.from(fresh.querySelectorAll('input[type=checkbox]')).map(input => [input.name + '\n' + input.value,input]));
        this.querySelectorAll('input[type=checkbox]').forEach(input => {
          const matching = options.get(input.name + '\n' + input.value);
          input.disabled = !input.checked && (!matching || matching.disabled);
          input.closest('label').toggleAttribute('data-unavailable',input.disabled);
          input.closest('label').querySelector('.bj-filters__option-count').textContent = matching?.closest('label').querySelector('.bj-filters__option-count').textContent || '(0)';
        });
        this.syncDropdown();
        if (this.popupStatus) this.popupStatus.textContent = fresh.dataset.count + ' matching products';
      } catch(error) {
        if (error.name === 'AbortError' || version !== this.version) return;
        if (apply && !this.popupStatus) {
          location.assign(destination.href);
          return;
        }
        this.status.textContent = 'Select View results to apply your filters.';
        this.view.textContent = 'View results';
        if (apply && this.popupStatus) {
          this.popupStatus.textContent = 'Could not update products. ';
          const retry = document.createElement('button');
          retry.type = 'button';
          retry.textContent = 'Retry';
          retry.addEventListener('click',() => this.refresh(this.version,true,target,pop),{once:true});
          this.popupStatus.append(retry);
        }
      } finally {
        if (version === this.version) this.section.querySelector('.sf--collection-container')?.removeAttribute('aria-busy');
      }
    }
    bindDesktop() {
      this.section = this.closest('.shopify-section');
      this.desktopEvents = new AbortController();
      const signal = this.desktopEvents.signal;
      document.addEventListener('click',event => {
        if (this.popup && !this.popup.contains(event.target) && !this.opener?.contains(event.target)) this.closeDropdown();
        if (!matchMedia('(min-width:1000px)').matches) return;
        const link = event.target.closest('.berrys-filter-active a,.collection__results .empty-state a[is="facet-link"]');
        if (!link || !this.section.contains(link) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.loadURL(new URL(link.href));
      },{capture:true,signal});
      document.addEventListener('change',event => {
        if (!event.target.matches('.berrys-filter-shell [data-berrys-category-sort]') || !this.section.contains(event.target)) return;
        event.stopImmediatePropagation();
        const url = this.buildURL();
        url.searchParams.set('sort_by',event.target.value);
        this.loadURL(url);
      },{capture:true,signal});
      document.addEventListener('keydown',event => {
        if (event.key === 'Escape' && this.popup) {event.preventDefault();this.closeDropdown(true);}
      },{signal});
      document.addEventListener('focusin',event => {
        if (this.popup && !this.popup.contains(event.target) && event.target !== this.opener) this.closeDropdown();
      },{signal});
      window.addEventListener('popstate',() => {
        if (this.dialog.open) this.dialog.close();
        this.closeDropdown();
        this.loadURL(new URL(location.href),true);
      },{signal});
      window.addEventListener('resize',() => this.closeDropdown(),{signal});
    }
    loadURL(url,pop = false) {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.version++;
      this.liveApply = true;
      this.refresh(this.version,true,url,pop);
    }
    closeDropdown(focus = false) {
      if (!this.popup) return;
      this.popup.remove();
      this.popup = null;
      this.popupStatus = null;
      this.opener?.setAttribute('aria-expanded','false');
      this.opener?.setAttribute('aria-controls',this.dialog.id);
      if (focus) this.opener?.focus({preventScroll:true});
    }
    openDropdown(button) {
      if (this.popup && this.opener === button) {this.closeDropdown(true);return;}
      this.closeDropdown();
      const group = Array.from(this.querySelectorAll('[data-bj-group]')).find(g => g.dataset.bjGroup === button.dataset.filter);
      if (!group) return;
      this.liveApply = true;
      this.opener = button;
      this.dropdownGroup = group;
      const popup = document.createElement('div');
      this.popup = popup;
      popup.className = 'bj-filter-dropdown';
      popup.id = 'bj-quick-' + this.dataset.section;
      popup.setAttribute('role','region');
      popup.setAttribute('aria-label',group.querySelector('summary').textContent.trim());
      button.setAttribute('aria-controls',popup.id);
      button.setAttribute('aria-expanded','true');
      const options = group.querySelector('.bj-filters__options').cloneNode(true);
      options.querySelectorAll('[data-bj-min],[data-bj-max]').forEach(input => { input.type = 'text'; input.inputMode = 'decimal'; input.placeholder = this.formatPrice(input.placeholder.replace(/,/g,'')); });
      popup.append(options);
      popup.addEventListener('focusout', () => this.syncDropdown());
      this.popupStatus = document.createElement('p');
      this.popupStatus.className = 'bj-filter-dropdown__status';
      this.popupStatus.setAttribute('role','status');
      popup.append(this.popupStatus);
      button.insertAdjacentElement('afterend',popup);
      const rect = button.getBoundingClientRect();
      const shellRect = popup.offsetParent.getBoundingClientRect();
      const left = Math.max(0,Math.min(rect.left - shellRect.left,shellRect.width - popup.offsetWidth));
      popup.style.left = left + 'px';
      popup.style.top = rect.bottom - shellRect.top + 8 + 'px';
      const update = event => {
        const input = event.target;
        if (!input.matches('input')) return;
        if (input.type === 'checkbox' && event.type !== 'change') return;
        if (input.type !== 'checkbox' && event.type !== 'input') return;
        let original;
        if (input.type === 'range') {
          original = group.querySelector(input.hasAttribute('data-bj-range-min') ? '[data-bj-range-min]' : '[data-bj-range-max]');
          original.value = input.value;
          this.syncPrice(original);
        } else {
          original = Array.from(group.querySelectorAll('input')).find(i => i.name === input.name && (input.type !== 'checkbox' || i.value === input.value));
          if (!original) return;
          if (input.type === 'checkbox') original.checked = input.checked; else original.value = input.value.replace(/[£,\s]/g,'');
        }
        this.changed();
        this.syncDropdown();
        if (input.type === 'checkbox') this.closeDropdown(true);
      };
      popup.addEventListener('input',update);
      popup.addEventListener('change',update);
      this.syncDropdown();
      popup.querySelector('input:not(:disabled)')?.focus({preventScroll:true});
    }
    formatPrice(value) {
      return value === '' ? '' : '£' + Number(value).toLocaleString('en-GB', { maximumFractionDigits: 2 });
    }
    syncDropdown() {
      if (!this.popup) return;
      const originals = Array.from(this.dropdownGroup.querySelectorAll('input'));
      this.popup.querySelectorAll('input').forEach(input => {
        const original = originals.find(i => input.type === 'range'
          ? i.type === 'range' && i.hasAttribute(input.hasAttribute('data-bj-range-min') ? 'data-bj-range-min' : 'data-bj-range-max')
          : i.name === input.name && (input.type !== 'checkbox' || i.value === input.value));
        if (!original) return;
        if (input.type === 'checkbox') {
          input.checked = original.checked;
          input.disabled = original.disabled;
          input.closest('label').toggleAttribute('data-unavailable',input.disabled);
          input.closest('label').querySelector('.bj-filters__option-count').textContent = original.closest('label').querySelector('.bj-filters__option-count').textContent;
        } else if (input !== document.activeElement) input.value = input.matches('[data-bj-min],[data-bj-max]') ? this.formatPrice(original.value) : original.value;
      });
    }
    applyResults(doc,fresh,url,pop,syncValues) {
      const currentGrid = this.section.querySelector('.sf--collection-container');
      const nextGrid = doc.querySelector('.sf--collection-container');
      if (!currentGrid || !nextGrid) throw new Error('Missing product grid');
      if (syncValues) {
        const inputs = Array.from(fresh.querySelectorAll('input'));
        this.form.querySelectorAll('input[name]').forEach(input => {
          const next = inputs.find(i => i.name === input.name && (input.type !== 'checkbox' || i.value === input.value));
          if (input.type === 'checkbox') input.checked = !!next?.checked;
          else input.value = next?.value || '';
        });
        this.updateUI();
      }
      if (!pop && url.href !== location.href) history.pushState(null,'',url.pathname + url.search + url.hash);
      currentGrid.replaceWith(nextGrid);
      this.dataset.count = fresh.dataset.count;
      for (const selector of ['.berrys-filter-count','.berrys-filter-active']) {
        const old = this.section.querySelector(selector);
        const next = doc.querySelector(selector);
        if (old && next) old.replaceChildren(...next.childNodes);
      }
      this.section.querySelectorAll('.berrys-filter-quick [data-filter]').forEach(button => {
        const next = Array.from(doc.querySelectorAll('.berrys-filter-quick [data-filter]')).find(b => b.dataset.filter === button.dataset.filter);
        if (next) {
          button.replaceChildren(...next.childNodes);
          button.classList.toggle('is-active',next.classList.contains('is-active'));
        }
      });
      this.section.querySelectorAll('[data-berrys-category-sort]').forEach(select => {
        const next = doc.querySelector('[data-berrys-category-sort]');
        if (next) select.value = next.value;
      });
      document.dispatchEvent(new CustomEvent('bj:infinite-scroll:restored'));
    }
    disconnectedCallback() {
      this.closeDropdown();
      this.desktopEvents?.abort();
      clearTimeout(this.timer);
      this.controller?.abort();
      if (this.dialog.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow;
      }
    }
  }
  customElements.define('bj-collection-filters',CollectionFilters);
  document.addEventListener('click',event => {
    const button = event.target.closest('[data-bj-open]');
    if (!button) return;
    const drawer = button.closest('.shopify-section')?.querySelector('bj-collection-filters');
    if (drawer) {event.preventDefault();drawer.open(button);}
  });
})();

